import gql from 'graphql-tag';
import React, {ReactNode} from 'react';

import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {assertIsAccessible, assertAllAccessible} from 'graphql-client/InaccessibleInfo';
import {
  SubtemplatePublishingVersionHistoryPanelQuery,
  SubtemplatePublishingVersionHistoryPanelQueryVariables,
} from 'template-collectibles/publishing-ui/graphql/__generated/SubtemplatePublishingVersionHistoryPanelQuery';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {PublishingRecordForVersionHistoryPanel} from './types';

export const SUBTEMPLATE_PUBLISHING_VERSION_HISTORY_PANEL_QUERY = gql`
  query SubtemplatePublishingVersionHistoryPanelQuery($subtemplateId: StrictString!)
  @skipAudit
  @engComponent(name: NOTEBOOK) {
    subtemplate(id: $subtemplateId) {
      ... on SubtemplateNode {
        id
        ...PublishingRecordsForVersionHistoryPanelGraphQL
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
  ${getFragmentWrapper('PublishingRecordsForVersionHistoryPanel').fragment}
`;

export function SubtemplatePublishingVersionHistoryPanelBenchlingQuery({
  children,
  subtemplateId,
}: {
  children: (publishingRecords: Array<PublishingRecordForVersionHistoryPanel>) => ReactNode;
  subtemplateId: string;
}): JSX.Element {
  return (
    <BenchlingQuery<
      SubtemplatePublishingVersionHistoryPanelQuery,
      SubtemplatePublishingVersionHistoryPanelQueryVariables
    >
      query={SUBTEMPLATE_PUBLISHING_VERSION_HISTORY_PANEL_QUERY}
      variables={{subtemplateId}}
      renderLoading={() => <CenteredHorizontalThrobber />}
    >
      {({subtemplate}) => {
        const accessibleSubtemplate = assertIsAccessible(subtemplate);
        const publishingRecords: Array<PublishingRecordForVersionHistoryPanel> = assertAllAccessible(
          accessibleSubtemplate.publishingRecords
        );
        return children(publishingRecords);
      }}
    </BenchlingQuery>
  );
}
